import axios from 'axios'
import API from '@/common/api'
import router from '../../router'
import store from '..'
import regExp from '@/common/regExp'

export default {
  namespaced: true,
  state: {
    layerpopup: [],
    active: null
  },
  mutations: {
    setActive (state, id) {
      state.active = id
    },
    setLayerpopup (state, data) {
      const list = data.list && data.list.length ? data.list : null
      const mainPageId = store.getters['common/getSetting'] && store.getters['common/getSetting'].main.page
      // 바닥 url 유효한지?
      const validTarget = function (url) {
        let isValid = false
        let targetId = ''
        const type = url.type
        switch (type) {
          case 'page':
            if (url.pageId && regExp.replaceAllEmpty(url.pageId).length) {
              isValid = true
              targetId = url.pageId === 'main' ? mainPageId : url.pageId
            }
            break
          case 'product':
            if (url.productId && regExp.replaceAllEmpty(url.productId).length) {
              isValid = true
              targetId = url.productId
            }
            break
          case 'reservation':
            if (url.reservationId && regExp.replaceAllEmpty(url.reservationId).length) {
              isValid = true
              targetId = url.reservationId
            }
            break
          case 'shortcut':
            if (url.shortcutId && regExp.replaceAllEmpty(url.shortcutId).length) {
              isValid = true
              targetId = url.shortcutId
            }
            break
          default:
            break
        }
        return {
          isValid: isValid,
          target: url.type,
          targetId: targetId
        }
      }
      if (list && list.length) {
        state.layerpopup = list.filter(x => x.service).map(x => {
          return {
            id: x.id,
            name: x.name,
            setting: x.setting,
            ...validTarget(x.url),
            popup: x.popup.filter(p => { // 팝업은 무조건 페이지여야하므로 pageid만 필요함
              return p.type === 'page' && ((p.pageId_input_active && regExp.replaceAllEmpty(p.pageIdInput).length) || regExp.replaceAllEmpty(p.pageId).length)
            }).map(p => {
              return p.pageId_input_active ? p.pageIdInput : p.pageId
            })
          }
        }).filter(x => x.isValid && x.popup.length)
      }
    }
  },
  actions: {
    async getLayerpopup ({ dispatch, commit, state }) {
      const file = 'layerpopup/layerpopup.json'
      return axios.get(`${API.BASE_URL}/castit/file?cmd=get-file&siteid=${API.SITE_INFO.site}&file=${file}`).then(res => {
        if (res && res.data && res.data.message) {
          commit('setLayerpopup', res.data.message)
          return res.data.message
        }
      }).catch((ex) => {
        return false
      })
    }
  },
  getters: {
    getLayerpopup: state => state.layerpopup
  }
}
